import { useMemo } from 'react';

const useSourceOfLead = () => {
  const url = typeof window !== 'undefined' ? window.location.href : '';
  const queryParams = typeof window !== 'undefined' ? window.location.search : '';

  const IS_TIER1_PAGE = url.includes('audiusa.com') || url.includes('audi.ca');
  const IS_VDP_PAGE = url.includes('vehicle') && queryParams.includes('vehicleId');
  const IS_VLP_PAGE = url.includes('inventory') && !url.includes('vehicle');
  const IS_OFFERS_PAGE = url.includes('promotions') || url.includes('offers');
  const IS_BUILD_PAGE = url.includes('build');
  const IS_MODELS_PAGE =
    url.includes('models') && !url.includes('find-your-match') && !url.includes('build');
  const IS_FYM_PAGE = url.includes('find-your-match');

  const generalSource = useMemo(() => {
    if (IS_TIER1_PAGE) return 'tier_1';
    return 'tier_3';
  }, [IS_TIER1_PAGE]);

  const specificSource = useMemo(() => {
    if (IS_VLP_PAGE) return 'vlp';
    if (IS_VDP_PAGE) return 'vdp';
    if (IS_OFFERS_PAGE && !IS_TIER1_PAGE) return 'specials';
    if (IS_OFFERS_PAGE) return 'offers';
    if (IS_BUILD_PAGE) return 'config';
    if (IS_MODELS_PAGE) return 'mlp';
    // Temp solution
    // if (IS_FYM_PAGE) return 'fym';
    if (IS_FYM_PAGE) return 'vlp';
    return IS_TIER1_PAGE ? 'generic' : 'general';
  }, [
    IS_BUILD_PAGE,
    IS_FYM_PAGE,
    IS_MODELS_PAGE,
    IS_OFFERS_PAGE,
    IS_TIER1_PAGE,
    IS_VDP_PAGE,
    IS_VLP_PAGE,
  ]);

  return { url, generalSource, specificSource };
};

export default useSourceOfLead;
